import './index.styl'
import KButton from './KButton.vue'
import KCard from './KCard.vue'
import KInput from './KInput.vue'
import KPage from './KPage.vue'
import KTag from './KTag.vue'
import KSelect from './KSelect.vue'
import KDialog from './KDialog.vue'
import KDrawer from './KDrawer.vue'
import KInputText from './KInputText.vue'

export default class KeepUi {
  static install(vue) {
    vue.component('KPage', KPage)
    vue.component('KButton', KButton)
    vue.component('KCard', KCard)
    vue.component('KInput', KInput)
    vue.component('KTag', KTag)
    vue.component('KSelect', KSelect)
    vue.component('KDialog', KDialog)
    vue.component('KDrawer', KDrawer)
    vue.component('KInputText', KInputText)
  }
}
